var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title"},[_vm._v("接口说明")]),_c('p',[_vm._v("请求地址："+_vm._s(_vm.requestUrl))]),_c('p',[_vm._v("请求方法："+_vm._s(_vm.requestMethod))]),(!_vm.isHide)?_c('p',[_vm._v("请求头：Token (调用接口的凭证，通过获取Token 接口获得)")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }